export const domain_vizr = process.env.REACT_APP_DOMAIN_VIZR;
export const OPEN_DETAILS_POPUP = 'OPEN_DETAILS_POPUP';
export const LOCATION = 'location';
export const COUNTRY = 'country';
export const POLICYID = 'policyId';
export const OWNERID = 'ownerId';
export const DATA_ASSETS = 'dataAssets';
export const BEHAVIORMODEL = 'behaviormodels';
export const ROLES = 'roles';
export const ROLE_NAME = 'roleName';
export const ACTIVE_USERS = 'activeUsers';
export const PUBLIC_DATA = 'publicdata';
export const POLICY = 'policy';
export const DATASOURCE = 'dataSource';
export const ACTIVITIES = 'activities';
export const USERS = 'users';
export const ANOMALIES = 'anomalies';
export const OPEN_ANOMALIES = 'openAnomalies';
export const ASSETS = 'dataAssets';
export const FETCH_POPUP_DATA = 'FETCH_POPUP_DATA';
// Popup related constants
export const SET_POPUP_DATA = "SET_POPUP_DATA";
export const SET_POPUP_OPEN = "SET_POPUP_OPEN";
export const SET_POPUP_LOADER = "SET_POPUP_LOADER";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const SET_POPUP_PAGINATION = "SET_POPUP_PAGINATION";
export const SET_POPUP_AGGREGATION_DATA = "SET_POPUP_AGGREGATION_DATA";
export const UPDATE_ALERT_STATUS_REQUEST_DATAGUARD = "UPDATE_ALERT_STATUS_REQUEST_DATAGUARD";
export const getHierarcyDataKey = (hierarcy) => {
    return hierarcy + '_DATA';
}
export const getTotalHierarcyKey = (hierarcyList) => {
    return hierarcyList.join('_');
}
export const API_MAP = {
    [getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ACTIVITIES])]: '/dataguard/location/metrics?metric=activities',
    [getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,USERS])]: '/dataguard/location/metrics?metric=users',
    [getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ANOMALIES])]: '/dataguard/location/metrics?metric=anomalies',
    [getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ASSETS])]: '/dataguard/location/metrics?metric=dataAssets',
    [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, USERS])]: '/dataguard/behaviorModel/metrics?metric=users',
    [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES])]: '/dataguard/behaviorModel/metrics?metric=allAnomalies',
    [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES])]: '/dataguard/behaviorModel/metrics?metric=openAnomalies',
    [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS])]: '/dataguard/publicDataAssets/metrics?metric=allAssets',
    [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES])]: '/dataguard/publicDataAssets/metrics?metric=accesses',
    [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY])]: '/dataguard/publicDataAssets/metrics?metric=byLocation',
    [getTotalHierarcyKey([ROLES, DATASOURCE, USERS])]: '/dataguard/userRoles/metrics?metric=allUsers',
    [getTotalHierarcyKey([ROLES, DATASOURCE, ACTIVE_USERS])]: '/dataguard/userRoles/metrics?metric=activeUsers',
    [getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES])]: '/dataguard/userRoles/metrics?metric=anomalies',
    [getTotalHierarcyKey([ROLES, DATASOURCE, COUNTRY])]: '/dataguard/userRoles/metrics?metric=byLocation'
};
export const getAPIEndpoint = (hierarcy) => {
    const key = getTotalHierarcyKey(hierarcy);
    return domain_vizr + API_MAP[key];
}
function getAPIParams(hierarcy, params) {
    const key = getTotalHierarcyKey(hierarcy);
    let finalParams = `page=${params.page}&size=${params.pageSize}&fromTimeStamp=${params.fromTimeStamp}&toTimeStamp=${params.toTimeStamp}`;
    switch (key) {
        case getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ACTIVITIES]):
        case getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,USERS]):
        case getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ANOMALIES]):
        case getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ASSETS]):
            return finalParams + `&country=${encodeURIComponent(params[getHierarcyDataKey(COUNTRY)])}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}`;
        case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, USERS]):
        case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES]):
        case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES]):
            return finalParams + `&policySubtype=${params[getHierarcyDataKey(POLICYID)]}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}`;
        case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS]):
        case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES]):
            return finalParams + `&ownerId=${params[getHierarcyDataKey(OWNERID)]}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}`;
        case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY]):
            return finalParams + `&ownerId=${params[getHierarcyDataKey(OWNERID)]}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}&country=${encodeURIComponent(params[getHierarcyDataKey(COUNTRY)])}`;
        case getTotalHierarcyKey([ROLES, DATASOURCE, USERS]):
        case getTotalHierarcyKey([ROLES, DATASOURCE, ACTIVE_USERS]):
        case getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES]):
            return finalParams + `&roleName=${encodeURIComponent(params[getHierarcyDataKey(ROLE_NAME)])}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}`;
        case getTotalHierarcyKey([ROLES, DATASOURCE, COUNTRY]):
            return finalParams + `&roleName=${encodeURIComponent(params[getHierarcyDataKey(ROLE_NAME)])}&dataSourceId=${params[getHierarcyDataKey(DATASOURCE)]}&country=${encodeURIComponent(params[getHierarcyDataKey(COUNTRY)])}`;
        default:
            return finalParams;
    }
}
export const getFinalURL = (hierarchy, params) => {
    let url = getAPIEndpoint(hierarchy) + '&' + getAPIParams(hierarchy, params);
    return url;
}

const AlertAggregationAPIMap = {
    [getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ANOMALIES])]: '/dataguard/location/anomaliesCount',
    [getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES])]: '/dataguard/userRoles/anomaliesCount',
};

const getAPIParamsAlertAgg = (hierarcy, popupDetails) => {
    const key = getTotalHierarcyKey(hierarcy);
    switch (key) {
        case getTotalHierarcyKey([LOCATION,COUNTRY,DATASOURCE,ANOMALIES]):
            return `?country=${encodeURIComponent(popupDetails[getHierarcyDataKey(COUNTRY)])}&dataSourceId=${popupDetails[getHierarcyDataKey(DATASOURCE)]}`;
        case getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES]):
            return `?roleName=${encodeURIComponent(popupDetails[getHierarcyDataKey(ROLE_NAME)])}&dataSourceId=${popupDetails[getHierarcyDataKey(DATASOURCE)]}`;
        default:
            return '';
    }
};

export const staticAlertCount = [
    getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES]),
    getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES]),
];

export const getAlertAggregationURL = (hierarcy, fromTimeStamp, toTimeStamp, popupDetails) => {
    const key = getTotalHierarcyKey(hierarcy);
    const baseURL = AlertAggregationAPIMap[key];
    if (baseURL) {
        return domain_vizr + baseURL + getAPIParamsAlertAgg(hierarcy, popupDetails) + `&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`;
    }
    return null;
};